import React, {Component} from 'react'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend/index'
import GlobalHelper from '../GlobalHelper.jsx'
import DebounceInput from 'react-debounce-input';

class InputHoursMinutes extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            id: this.props.id || '',
            measure: this.props.measure || '',
            className: this.props.className || '',
            groupClassName: this.props.groupClassName || '',
            format: this.props.format || 'normal',
            disabled: this.props.disabled === true,
            verticalAlignment: this.props.verticalAlignment || false,
            hour: this.convertMeasureToHour(),
            minute: this.convertMeasureToMinute(),
        }
        this.convertMeasureToHour = this.convertMeasureToHour.bind(this)
        this.convertMeasureToMinute = this.convertMeasureToMinute.bind(this)
        this.onHoursMinutesChange = this.onHoursMinutesChange.bind(this)
        this.handleHoursMinutes = this.handleHoursMinutes.bind(this)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                hour: this.convertMeasureToHour(),
                minute: this.convertMeasureToMinute()
            })
        }
    }

    convertMeasureToHour() {
        return this.props.value ? Math.trunc(parseFloat(this.props.value)) : 0
    }

    convertMeasureToMinute() {
        return this.props.value ? Math.trunc(parseFloat(this.props.value) * 60 % 60) : 0
    }

    handleHoursMinutes() {
        let value = parseInt(this.state.hour) + parseInt(this.state.minute) / 60
        this.props.onChange(value.toString())
    }

    onHoursMinutesChange(event) {
        if (!event.target) {
            return
        }
        this.setState({
            [event.target.name]: Math.trunc(event.target.value)
        }, () => {
            this.handleHoursMinutes()
        })
    }

    render() {
        return <span style={{flex: "0 0 6em"}} className={this.state.groupClassName}>
        <div className={"input-group " + this.state.groupClassName} style={{flex: "0 0 6em"}}>
            <DebounceInput
                disabled={this.state.disabled}
                name={'hour'}
                id={this.state.id || this.state.name}
                type="number"
                className={"form-control " + this.state.className}
                placeholder={GlobalHelper.applyLocaleDecimal('0', AppContext.getLocale().getLanguage())}
                value={this.state.hour}
                onChange={this.onHoursMinutesChange}
                min={0}
                minLength={0}
                debounceTimeout={300}
                autoComplete="off"
                onFocus={e => e.target.select()}
                onClick={e => e.target.select()}
            />
            <div
                className={this.state.verticalAlignment ? 'input-group-append ' : 'w-100 ml-0 bg-light d-flex align-items-center text-center'}>
                {this.state.verticalAlignment ? <span className={"input-group-text " +
                    (this.state.format === 'short' ? 'px-2' : '')} id="basic-addon2">h</span> :
                    <small className={'w-100 rounded-0 px-2 py-1'} id="basic-addon2">h</small>}
            </div>
        </div>
        <div className={"input-group " + this.state.groupClassName} style={{flex: "0 0 6em"}}>
            <DebounceInput
                disabled={this.state.disabled}
                name={'minute'}
                id={this.state.id || this.state.name}
                type="number"
                className={"form-control " + this.state.className}
                placeholder={GlobalHelper.applyLocaleDecimal('0', AppContext.getLocale().getLanguage())}
                value={this.state.minute}
                onChange={this.onHoursMinutesChange}
                min={0}
                minLength={0}
                debounceTimeout={300}
                autoComplete="off"
                onFocus={e => e.target.select()}
                onClick={e => e.target.select()}
            />
            <div
                className={this.state.verticalAlignment ? 'input-group-append d-flex align-items-center' : 'w-100 ml-0 bg-light d-flex align-items-center text-center'}>
                {this.state.verticalAlignment ? <span className={"input-group-text " +
                    (this.state.format === 'short' ? 'px-1' : '')} style={{minWidth: '27px', maxWidth: '36px'}} id="basic-addon2">m</span> :
                    <small className={'w-100 rounded-0 px-2 py-1'}
                           id="basic-addon2">m</small>}
            </div>
        </div>
    </span>

    }
}

export default InputHoursMinutes


// WEBPACK FOOTER //
// ./src/common/unit-of-measure/inputhoursminutes.component.jsx